import { Injectable } from '@angular/core';
import { CommonConstants } from 'src/app/shared/constant';
import { BearerToken } from './../models/bearer.token';
import { EncryptionService } from './encryption.service';

@Injectable()
export class TokenService {
  constructor(private readonly encryptionService: EncryptionService) {}
  private readonly tokenKey: string = CommonConstants.authorizationKey;

  public setToken(token: BearerToken, isLongTerm: boolean): void {
    //const json = JSON.stringify(token);
    const json = this.encryptionService.setJson(token);
    if (isLongTerm) {
      localStorage.setItem(this.tokenKey, json);
    } else {
      sessionStorage.setItem(this.tokenKey, json);
    }
  }

  public getToken(): BearerToken {
    let storedToken: any = localStorage.getItem(this.tokenKey);

    if (storedToken == null) {
      storedToken = sessionStorage.getItem(this.tokenKey);
    }

    if (storedToken == null) {
      return null;
    }

    // const json: any = JSON.parse(storedToken);
    const json = this.encryptionService.getJson(storedToken);
    const token: BearerToken = new BearerToken(json);

    if (token.isExpired()) {
      this.removeToken();
      return null;
    } else {
      return token;
    }
  }

  public removeToken(): void {
    localStorage.removeItem(this.tokenKey);
    sessionStorage.removeItem(this.tokenKey);
  }
}
